import React, { useEffect, useState } from 'react';
import { fetchFilteredProducts } from '../../graphql/api/productApi';
import ProductCard from '../ProductCard';
import NoData from '../NoData';
import { FilterProps } from './filter';
import Loading from '../Loading';

const ProductList: React.FC<FilterProps> = ({
  minPrice,
  maxPrice,
  categoryId,
  inStock,
  limit,
  offset,
  searchQuery = '',
}) => {
  const [products, setProducts] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string>();

  useEffect(() => {
    setLoading(true);
    fetchFilteredProducts(minPrice, maxPrice, categoryId, inStock, limit, offset)
      .then(nodes => setProducts(nodes))
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  }, [minPrice, maxPrice, categoryId, inStock, limit, offset]);

  // ✅ Local search filtering
  const filtered = products.filter(product =>
    product.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  if (loading) return <Loading />;
  if (error) return <p>Error: {error}</p>;

  return (
    <div className="category_grid">
      {filtered.length > 0 ? (
        filtered.map(prod => <ProductCard key={prod.id} product={prod} />)
      ) : (
        <NoData message="No products found." />
      )}
    </div>
  );
};

export default ProductList;
